module.exports = __webpack_public_path__ + "media/images/sub-ee52add37a89cee60802c0cb3c16319c.svg";